/**
 * Geography Domain Mappers
 * Maps transport layer DTOs to domain models
 */

import type { LC_GetRegionsOut, LC_GetCommunesByRegionOut, Region, Commune } from './geography.types';

/**
 * Maps regions response from backend to UI domain model
 * Backend sends array directly in envelope.data
 */
export const mapRegions = (out: LC_GetRegionsOut): Region[] => {
  if (!out) return [];
  return out.map((region) => ({ 
    id: region.id, 
    name: region.regionName, 
  }));
};

/**
 * Maps communes response from backend to UI domain model
 * Backend sends array directly in envelope.data
 */
export const mapCommunes = (out: LC_GetCommunesByRegionOut): Commune[] => {
  if (!out) return [];
  return out.map((commune) => ({ 
    id: commune.id, 
    name: commune.name, 
  }));
};
